import React, { useEffect, type JSX } from 'react';
// Import Tailwind CSS only for the landing page
import '../../tailwind.css';
import Hero from '../../components/Hero';
import ProblemSolution from '../../components/ProblemSolution';
import Benefits from '../../components/Benefits';
import Pricing from '../../components/Pricing';
import Testimonials from '../../components/Testimonials';
// import Experts from '../../components/Experts';
import FAQ from '../../components/FAQ';
import CTA from '../../components/CTA';
import { trackViewContent } from '../../components/FacebookPixel';

/**
 * Landing page component with all marketing sections
 * Copied from the feelheard project
 */
export function LandingPage(): JSX.Element {
  // Handle hash-based navigation scrolling when the component mounts
  useEffect(() => {
    // Check if there's a hash in the URL
    if (window.location.hash) {
      // Get the target element by ID (removing the # from the hash)
      const id = window.location.hash.substring(1);
      const element = document.getElementById(id);
      
      // If the element exists, scroll to it
      if (element) {
        // Use setTimeout to ensure DOM is fully rendered
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }

    // Track view content event for homepage
    trackViewContent({
      content_name: 'FeelHeard Homepage',
      content_type: 'landing_page'
    });
  }, []);

  return (
    <>
      <Hero />
      <ProblemSolution />
      <Benefits />
      <Pricing />
      <Testimonials />
      {/* <Experts /> */}
      <FAQ />
      <CTA />
    </>
  );
}